module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "xdefi.ace603cc.svg";